import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import FormLayout from './FormLayout';
import SpinnerAnimation from '../../components/Spinner';
import { confirmRegistration } from '../../queries/authentication';

/**
 * Component to handle email confirmation links from registration emails.
 * Extracts email and confirmation_code from URL query params and calls the API.
 * Based on backend response, navigates user to appropriate page.
 */
const RegistrationConfirm = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [confirming, setConfirming] = useState(true);
  const [messageObject, setMessageObject] = useState(null);

  useEffect(() => {
    const email = searchParams.get('email');
    const confirmationCode = searchParams.get('confirmation_code');

    if (!email || !confirmationCode) {
      setConfirming(false);
      setMessageObject({message: 'Invalid confirmation link. Please check your email and try again.',
                        type: 'error'});
      return;
    }

    // Call the API to confirm registration
    confirmRegistration(email, confirmationCode)
      .then(result => {
        // API returns: { confirmationStatus: number, username: string }
        const { confirmationStatus, username } = result;

        // Navigate based on confirmation status
        // Status codes from backend:
        // 0 = success, navigate to signin
        // 1 = UserNotFoundException
        // 2 = UserNotConfirmedException
        // 3 = LinkExpired
        // 4 = ConfirmationFailed
        // 5 = NotAuthorized

        navigate('/register', {
          replace: true,
          state: {
            username: username || email,
            message: null
          }
        });

        // Add confirmationStatus to URL for Registration component to handle
        const params = new URLSearchParams();
        params.set('confirmationStatus', confirmationStatus);
        navigate(`/register?${params.toString()}`, {
          replace: true,
          state: {
            username: username || email,
            message: null
          }
        });
      })
      .catch(error => {
        setConfirming(false);
        setMessageObject({message: error?.message || 'Confirmation failed. Please try again or request a new confirmation link.',
                          type: 'error', name: error?.name});
      });
  }, [searchParams, navigate]);

  return (
    <FormLayout message={messageObject}>
      <div style={{ textAlign: 'center', padding: '2rem' }}>
        {confirming ? (
          <>
            <p>Confirming your email address...</p>
            <SpinnerAnimation style={{ margin: '1rem auto' }} />
          </>
        ) : (
          <p>
            <button
              className="login-submit"
              onClick={() => navigate('/register', { replace: true })}
            >
              Return to Registration
            </button>
          </p>
        )}
      </div>
    </FormLayout>
  );
};

export default RegistrationConfirm;